import React from "react";
import Layout from './Layout';
import { UpdateEmail } from "../../components/User/Update";

export const UpdateEmailPage = () => <Layout><UpdateEmail></UpdateEmail></Layout> 
